// src/hooks/useOrderApproval.js
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase"; // ✅ ensure this path is inside src/

export function useOrderApproval() {
  const approveOrder = async (order, clientId) => {
    if (!order?.docId || !clientId) {
      throw new Error("❌ Missing order or client ID");
    }

    const orderRef = doc(db, "Clients", clientId, "orders", order.docId);
    const orderSnap = await getDoc(orderRef);

    if (!orderSnap.exists()) {
      throw new Error("❌ Order not found");
    }

    const items = orderSnap.data().items || [];

    for (const item of items) {
      const itemId = item.id || item.itemId; // ✅ ensure key matches your data
      const qtyOrdered = parseFloat(item.qty) || 0;

      if (!itemId || qtyOrdered <= 0) continue;

      const inventoryRef = doc(db, "Clients", clientId, "inventories", itemId);
      const inventorySnap = await getDoc(inventoryRef);

      if (!inventorySnap.exists()) {
        console.warn(`⚠️ Inventory item ${itemId} not found`);
        continue;
      }

      const inventory = inventorySnap.data();
      const currentQty = parseFloat(inventory.qty) || 0;
      const newQty = Math.max(0, currentQty - qtyOrdered);

      await updateDoc(inventoryRef, { qty: newQty });
    }

    await updateDoc(orderRef, { status: "Approved" });
  };

  return { approveOrder };
}
